const Summary = () => {
    return ( 
        <div className = "summary">
            <h1>Select or create a Channel</h1>
        </div>
     );
}
 
export default Summary;